import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
const LABEL_SX = {
  m: 0,
  fontSize: "0.6875rem",
  lineHeight: 1.3,
  color: "fields.placeholder",
  whiteSpace: "nowrap",
};

export const InsightPrimaryFigures = ({ figures = [] }) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "flex-end",
      gap: 2,
      flexShrink: 0,
    }}
  >
    {figures.map((figure) => (
      <Box key={figure.key} sx={{ textAlign: "right" }}>
        <Typography component="p" sx={LABEL_SX}>
          {figure.label}
        </Typography>
        <Typography
          component="p"
          sx={{
            m: 0,
            fontSize: "0.9375rem",
            fontWeight: 600,
            color: "text.primary",
            fontVariantNumeric: "tabular-nums",
            whiteSpace: "nowrap",
          }}
        >
          {figure.value}
        </Typography>
      </Box>
    ))}
  </Box>
);

export const InsightSecondaryMetrics = ({ items = [], singleRow = false }) => {
  if (!items.length) return null;

  return (
    <Box
      data-pdf-metrics
      sx={{
        display: "grid",
        gridTemplateColumns: `repeat(${
          items.length > 4 && !singleRow ? 3 : items.length
        }, minmax(0, 1fr))`,
        columnGap: 1.5,
        rowGap: 1,
        mt: 0.75,
      }}
    >
      {items.map((item) => (
        <Box key={item.key} sx={{ minWidth: 0 }}>
          <Typography component="p" sx={LABEL_SX}>
            {item.label}
          </Typography>
          <Typography
            component="p"
            sx={{
              m: 0,
              fontSize: "0.75rem",
              fontWeight: 600,
              color: "text.primary",
              fontVariantNumeric: "tabular-nums",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {item.value}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};
